import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import '@pushcaster/ui/styles.css'
import { ThemeProvider } from '@pushcaster/ui/theme-provider'

import { App } from './app'

/*
 * The entry point, and the shortest one in the workspace.
 *
 * The other two apps boot: they fetch `GET /system/config`, restore a session,
 * start the i18n runtime, and only then render. This one renders **first** and
 * fetches afterwards, because V1_2_SPEC.md §8 requires it to load with the
 * control plane down — a boot sequence that awaits the control plane is a status
 * page that goes blank in the one condition it was built for.
 *
 * So there is no `boot.tsx` here, and there should not be one. Everything the
 * shell needs to paint is in the bundle; everything the API provides arrives
 * into an already-rendered page.
 */

const container = document.getElementById('root')
if (container === null) {
  throw new Error('index.html has no #root element.')
}

createRoot(container).render(
  <StrictMode>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </StrictMode>,
)
